// Module dependencies
import experiments from 'app/common/lib/experiments';
import storage from 'app/common/lib/Storage';
import urlUtil from 'app/common/lib/urlUtil';

const SeamlessExperiment = {
  // Return whether seamless should be disabled based on the values in local storage
  // If disableSeamless was set to true less than an hour ago, return true, else false
  shouldDisable(referrer, setLocalStorage) {
    // nogw used for Yahoo! Japan's experiment
    // If nogw=true, their experiment is activated. If nogw is anything else, it is in control
    const urlParams = urlUtil.getQueryStringParams();
    if (urlParams.nogw === 'true') {
      if (referrer.indexOf('yahoo.co.jp') > -1) {
        if (setLocalStorage) {
          const now = new Date().getTime();
          storage.localStorage.setItem('disableSeamless', { disabled: 'true', ts: now });
        }
        return true;
      } else {
        return this.checkLocalStorage();
      }
    } else if (urlParams.nogw) {
      const now = new Date().getTime();
      storage.localStorage.setItem('disableSeamless', { disabled: 'false', ts: now });
      return false;
    }
    if (referrer.indexOf('yahoo.co.jp') > -1) {
      const jpGroup = experiments
        .getInstance()
        .v2ActivateExperiment('remove_seamless_from_yahoo_japan_v2');
      if (['enabled', 'employees'].includes(jpGroup)) {
        if (setLocalStorage) {
          const now = new Date().getTime();
          storage.localStorage.setItem('disableSeamless', { disabled: 'true', ts: now });
        }
        return true;
      }
    }
    return this.checkLocalStorage();
  },

  checkLocalStorage() {
    const disableSeamless = storage.localStorage.getItem('disableSeamless');
    if (disableSeamless && disableSeamless.disabled === 'true') {
      const timeCreated = storage.localStorage.getItem('disableSeamless').ts;
      const now = new Date().getTime();
      if (now - timeCreated > 3600000) {
        storage.localStorage.setItem('disableSeamless', { disabled: 'false', ts: now });
        return false;
      } else {
        return true;
      }
    }
    return false;
  },

  shouldShowSignupModal() {
    return !this.checkLocalStorage();
  },
};

export default SeamlessExperiment;
